export const CREATE_MAP_CONTRACT = `
  mutation CreateMapContract($input: MAPContractInput!) {
    createMapContract(input: $input) {
      error {
        code
        message
        statusCode
      }
      data {
        mapId
        mpeId
        mapType
        contractName
        startDate
        endDate
        creditPct
        committedSpend
        eligibleProductCodes
        accountsInScope
        tagValue
        status
        createdDate
        createdBy
        lastProcessedDate
      }
    }
  }
`
